/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Card, Button, Form, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { toast } from 'react-hot-toast';
import { loaderActions } from '../../../../../features/Loader/LoaderSlice';
import API from '../../../../../Services/API';
import _ from 'lodash';
import { downloadPurchaseOrderLines } from '../../../../../Helpers/xlxs/download';
import { DELIVERY_COMPLETED_FILTER } from '../../../../../Helpers/purchaseOrderFilters';

function ExportSupplierPOs(props) {
  const animatedComponents = makeAnimated();

  const dispatch = useDispatch();
  const [filteredVendors, setFilteredVendors] = React.useState([]);
  const [separateFile, setSeparateFile] = React.useState(false);
  const [selectedVendors, setSelectedVendors] = React.useState([]);
  const [excludeComplete, setExcludeComplete] = React.useState(false);

  async function exportWarehousePOs() {
    await dispatch(loaderActions.show());

    const EmmaParams = {
      company_id: process.env.REACT_APP_COMP_EMM
    };

    const DunParams = {
      company_id: process.env.REACT_APP_COMP_DUN
    };
    let uniqueVendors = [];
    let filter = '';
    let uniqueOrders = [];
    if (selectedVendors.length > 0) {
      uniqueVendors = [...new Set(selectedVendors.map((v) => v.value))];
    } else {
      uniqueVendors = [...new Set(props.vendors.map((v) => v.vendNo))];
    }
    await uniqueVendors.forEach((vendor, index) => {
      if (index === 0) {
        filter = `contains(vendorNo, '${vendor}')`;
      } else {
        filter = filter + ` or contains(vendorNo, '${vendor}')`;
      }
    });
    EmmaParams.$filter = filter;
    DunParams.$filter = filter;
    if (EmmaParams.$filter === '') delete EmmaParams.$filter;
    if (DunParams.$filter === '') delete DunParams.$filter;
    let allPos = [];

    if (excludeComplete) {
      const vendorConfirmationFilter = `and vendConfirmationSent eq true`;
      const deliveryCompletedFilter = `and ${DELIVERY_COMPLETED_FILTER}`;
      const params = {
        company_id: process.env.REACT_APP_COMP_EMM,
        $filter: `(${filter}) ${deliveryCompletedFilter} ${vendorConfirmationFilter}`.trim(),
        $select: `docNo`
      };
      const res = await API().get('/purchase_order_header', { params });
      uniqueOrders = [...new Set(res.data.value.map((line) => line.docNo))];
    }

    const EmmaRes = await API().get(`/purchase_order_lines`, { params: EmmaParams });
    const emmaPos = EmmaRes.data.value;
    const DunRes = await API().get(`/purchase_order_lines`, { params: DunParams });
    const dunPos = DunRes.data.value;
    allPos = emmaPos.concat(dunPos || []);

    if (allPos === 0) {
      toast.error('No POs found for the selected vendors');
    } else {
      if (excludeComplete) {
        allPos = allPos.filter(
          (line) =>
            [
              'Confirmation Sent to Vendor',
              'Confirmed by Vendor',
              'Confirmation Sent to Warehouse'
            ].includes(line.vendorPortalStatusCaption) &&
            line.vendConfirmationSent === true &&
            line.typeOfDeliveryCompleted === false &&
            uniqueOrders.includes(line.documentNo)
        );
      }
      if (separateFile) {
        const supplierPos = _.groupBy(allPos, 'vendorNo');
        const vendors = props.vendors;
        await _.forEach(supplierPos, async (supplierLines, key) => {
          const vendor = vendors.find((vend) => vend.vendNo === key);
          const vendorName = vendor ? vendor.vendName : key;
          await downloadPurchaseOrderLines(
            supplierLines,
            `Supplier-${vendorName}-POs-Lines`,
            'supplier'
          );
        });
      } else {
        await downloadPurchaseOrderLines(allPos, `All-Supplier-POs-Lines`, 'supplier');
      }
    }
    await dispatch(loaderActions.hide());
  }

  return (
    <>
      <Card className="p-4 ">
        <div className="text-center"></div>
        <Card.Body className="p-4">
          <Card.Title>
            <i className="feather icon-download mt-2" /> &nbsp; Export Supplier PO's
          </Card.Title>
          <Card.Text>
            Export PO's from all vendors to a CSV file. You can update the PO's accordingly and
            upload again to update.
          </Card.Text>
          <Row>
            <Col>
              <Form.Group controlId="vendors">
                <Form.Label>Vendors</Form.Label>
                <Select
                  components={animatedComponents}
                  options={props.vendors.map((v) => ({
                    value: v.vendNo,
                    label: v.vendName
                  }))}
                  value={selectedVendors}
                  isSearchable={true}
                  isMulti
                  onChange={(e) => {
                    setSelectedVendors(() => e);
                  }}
                />
                <Form.Text className="text-muted">Leave Empty for access to All Vendors</Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="separate">
                <Form.Check
                  type="checkbox"
                  label="Generate separate file for every vendor"
                  checked={separateFile}
                  onChange={(e) => setSeparateFile(() => e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="allOrdersSupplier">
                <Form.Check
                  type="checkbox"
                  label="Exclude completed orders(Export similar to Vendor Dashboard)"
                  checked={excludeComplete}
                  onChange={(e) => setExcludeComplete(() => e.target.checked)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Button variant="primary" onClick={exportWarehousePOs}>
            Export all Supplier lines
          </Button>
        </Card.Body>
      </Card>
    </>
  );
}

export default ExportSupplierPOs;
